import { useEffect } from "react";

function preloadImage(src: string) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => resolve(img);
    img.onerror = img.onabort = () => reject(src);
    img.src = src;
  });
}

async function preloadImages(images: string[]) {
  const imagesPromiseList: Promise<unknown>[] = [];
  for (const i of images) {
    imagesPromiseList.push(preloadImage(i));
  }

  await Promise.all(imagesPromiseList);
}

export function useImagePreloader(images: string[]) {
  useEffect(() => {
    preloadImages(images);
  }, [images]);
}
